export enum EventTypes {
  // @TODO should be merged with @instances/partners/SubmitTypes
  ERROR = 'error',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  VALID = 'valid',
}
